import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/products/detail/page'));
const ProductComparePage = lazy(() => import('../pages/products/compare/page'));
const WebsitesPage = lazy(() => import('../pages/websites/page'));
const DealDetailPage = lazy(() => import('../pages/websites/detail/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AffiliateLinksPage = lazy(() => import('../pages/affiliate-links/page'));
const ProductsManagementPage = lazy(() => import('../pages/products-management/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const OutreachPage = lazy(() => import('../pages/outreach/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const DiscoverPage = lazy(() => import('../pages/discover/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/products/compare',
    element: <ProductComparePage />
  },
  {
    path: '/products/:id',
    element: <ProductDetailPage />
  },
  {
    path: '/websites',
    element: <WebsitesPage />
  },
  {
    path: '/websites/:id',
    element: <DealDetailPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/affiliate-links',
    element: <AffiliateLinksPage />
  },
  {
    path: '/products-management',
    element: <ProductsManagementPage />
  },
  {
    path: '/resources',
    element: <ResourcesPage />
  },
  {
    path: '/outreach',
    element: <OutreachPage />
  },
  {
    path: '/partners',
    element: <PartnersPage />
  },
  {
    path: '/discover',
    element: <DiscoverPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
